module.exports = __webpack_public_path__ + "static/media/default_profile.36b409d1.png";